/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
export interface IHelpButtonComponentProps {
    gridSettings?: Msdyn365.IGridSettings;
    className?: string;
    typeName?: string;
    showButtonTooltip?: boolean;
    helpButtonPhoneNumber?: string;
    helpButtonAriaLabel?: string;
    helpButtonTitle?: string;
    helpButtonModalText?: string;
}
/**
 *
 * HelpButtonComponent.
 * @extends {React.PureComponent<IHelpButtonComponentProps>}
 */
export interface IHelpButtonComponentState {
    isHelpModalVisible: boolean;
}
export class HelpButtonComponent extends React.PureComponent<IHelpButtonComponentProps, IHelpButtonComponentState> {
    constructor(props: IHelpButtonComponentProps) {
        super(props);
        this.state = {
            isHelpModalVisible: false
        };
    }
    private handleButtonClick = () => {
        this.setState(prevState => ({ isHelpModalVisible: !prevState.isHelpModalVisible }));
    };
    private handleHelpModalClick = () => {
        if (this.props.helpButtonPhoneNumber) {
            const encodedNumber = encodeURIComponent(this.props.helpButtonPhoneNumber);
            const userAgent = navigator.userAgent;
            const isAppleDevice = /iPad|iPhone|iPod|Macintosh/.test(userAgent);
            if (isAppleDevice) {
                window.location.href = `facetime://${encodedNumber}`;
            } else {
                window.location.href = `tel:${encodedNumber}`;
            }
            this.handleCloseModals();
        } else {
            console.error('Phone number not set');
        }
    };
    private handleCloseModals = () => {
        this.setState({ isHelpModalVisible: false });
    };
    public render(): JSX.Element {
        return (
            <div className='ms-header__help-button-container'>
                <Button
                    title={this.props.helpButtonAriaLabel}
                    className={this.props.className}
                    aria-label={this.props.helpButtonAriaLabel}
                    onClick={this.handleButtonClick}
                >
                    <span className='msc-help-icon__text'>{this.props.helpButtonTitle}</span>
                </Button>
                {this.state.isHelpModalVisible && (
                    <div className='ms-header__help-modal' onClick={this.handleHelpModalClick}>
                        <p>{this.props.helpButtonModalText}</p>
                        <p className='ms-header__help-modal-phone'>{this.props.helpButtonPhoneNumber}</p>
                    </div>
                )}
            </div>
        );
    }
}
export default HelpButtonComponent;
